// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1t-0";
export var spinnerContainer = "_1t-1";